import { FileDto } from '@act/shared/data-transfer-objects';
import { useEffect } from 'react';
import { filesRequests } from 'redux/requests/files.requests';
import { useApiCall } from 'redux/utils/apiHook.hook';
import AudioPlayer from '../AudioPlayer';

const ViewFile = (props: { file: FileDto }) => {
  const [signedUrl, _loadingSignedUrl, getSignedUrl] = useApiCall(
    filesRequests.getSignedUrl
  );

  useEffect(() => {
    if (!signedUrl && props.file.id) {
      getSignedUrl({
        params: { id: props.file.id },
      });
    }
  }, []);

  const url = signedUrl?.temporaryUrl;

  if (props.file?.mimeType?.startsWith('video/')) {
    return (
      <video controls>
        <source src={url} type={props.file.mimeType} />
      </video>
    );
  } else if (props.file?.mimeType?.startsWith('audio/')) {
    return (
      <AudioPlayer
        fileId={props.file.id}
        mimeType={props.file.mimeType}
      ></AudioPlayer>
    );
  } else if (props.file?.mimeType?.startsWith('image/')) {
    return <img width="100%" height="auto" src={url} />;
  } else {
    return (
      <a href={url} target="_blank" rel="noreferrer">
        Download
      </a>
    );
  }
};

export default ViewFile;
